"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuloNode = void 0;
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'MODULO';
class ModuloNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            var _a;
            const val = params.value !== null ? Number(params.value) : NaN;
            const modulus = params.modulus !== null ? Number(params.modulus) : NaN;
            if (isNaN(val) || isNaN(modulus) || modulus === 0) {
                return { result: undefined };
            }
            const res = (_a = (0, gen5_shared_utilities_1.mod)(val, modulus)) !== null && _a !== void 0 ? _a : undefined;
            return { result: res };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.ModuloNode = ModuloNode;
ModuloNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Modulo',
    isIdempotent: true,
    primaryCategory: 'Math',
};
//# sourceMappingURL=Modulo.js.map